import { render, staticRenderFns } from "./FormText.vue?vue&type=template&id=9cf79bf4&"
import script from "./FormText.vue?vue&type=script&setup=true&lang=js&"
export * from "./FormText.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports